import React from "react";

import Link from "@busbud/design-system-components/dist/Link/Link";

import { useAppContext } from "@app/helpers/hooks";
import { clickedDownloadTickets } from "@app/tracking/account-tracking";

interface Props {
  pkpass_url: string;
  className?: string;
  tracker_name?: string;
}

export const AppleWalletTicket: React.FC<Props> = ({
  pkpass_url,
  className,
  tracker_name
}) => {
  const { locale, urlBuilder, translator, tracker } = useAppContext();
  const image_locale: AppleWalletSVGLocale = getImageLocale(locale);
  const img_src: string = urlBuilder.image(
    `app-wallets/apple/${image_locale}.svg`
  );

  return (
    <Link
      href={pkpass_url}
      target="_blank"
      onClick={() =>
        tracker.track(clickedDownloadTickets(tracker_name || "apple_wallet"))
      }
    >
      <img
        src={img_src}
        alt={translator.t("!download-tickets.apple-wallet")}
        className={className}
      />
    </Link>
  );
};

function getImageLocale(locale: string): AppleWalletSVGLocale {
  return AppleWalletSVGLocaleMap[locale] || "en";
}

type AppleWalletSVGLocale =
  | "en"
  | "es"
  | "es-mx"
  | "fr"
  | "it"
  | "pt"
  | "pt-br"
  | "ru"
  | "tr";

const AppleWalletSVGLocaleMap: Record<string, AppleWalletSVGLocale> = {
  "es-mx": "es-mx",
  "es-419": "es",
  "es-ar": "es",
  es: "es",
  fr: "fr",
  "fr-ca": "fr",
  it: "it",
  pt: "pt",
  "pt-pt": "pt-br",
  ru: "ru",
  tr: "tr",
  en: "en",
  "en-ca": "en",
  "en-gb": "en"
} as const;
